import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import {computed, getCurrentInstance, nextTick, watch} from 'vue';
import ObjectHelper from "~/ts/library/ObjectHelper";
import Delay from "~/ts/library/Delay";
import {toggleArrayElement} from "~/ts/library/ToggleArrayElement";
import Dictionary from "~/ts/library/Dictionary";
import {
    FIELD_TYPE_TEXT,
    FIELD_TYPE_TEXTAREA
} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {__} from "~/ts/library/Translate";
import {FormElementExposeInterface} from "~/cabinet/vue/interface/form/elements/useFormElement";
import SideMenuCardSection from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCardSection.vue";
import ClientField
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/fields/ClientField.vue";
import {
    CLIENT_FIELD_FIRST_NAME,
    NAME_FIELDS
} from "~/operatorApplication/ts/data/StandartClientFields";
import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import OpenApiResult from "~/ts/library/openApi/OpenApiResult";
import md5 from "~/ts/library/md5";
import Random from "~/ts/library/Random";


import AbstractFormElementOpenApiModel = OperatorApplicationApi.AbstractFormElementOpenApiModel;
import OperatorApplicationClientFieldAutoLinksOpenApiModel = OperatorApplicationApi.OperatorApplicationClientFieldAutoLinksOpenApiModel;

import {ref} from 'vue';

const __default__ = {
    name: "ClientFieldsList"
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    isClient: { type: Boolean },
    fieldValues: {},
    standartFieldNames: {},
    fields: {},
    links: {},
    readonly: { type: Boolean },
    showIcons: { type: Boolean },
    showTitles: { type: Boolean },
    isCustom: { type: Boolean },
    sendUpdateRequest: { type: Function }
  },
  setup(__props: any) {

let props = __props;

let visibleFieldNames = ref<string[]>([]);
let savingNow = ref<string[]>([]);
let fieldsModel = ref<Dictionary<any>>({});
let showSeparatedNameFields = ref(false);
let instanceId = Random.uid();

let instance = getCurrentInstance().proxy;

function isJoinedNameField(name: string) {
    return props.isClient && !showSeparatedNameFields.value && NAME_FIELDS.includes(name);
}

let computedVisibleFieldNames = computed(() => {
    let result = [...alwaysVisibleFieldNames.value];

    for (let field of fieldsOfSite.value) {
        if (hasValue(field)) {
            toggleArrayElement(result, field.name, true);
        }
    }

    for (let name of visibleFieldNames.value) {
        toggleArrayElement(result, name, true);
    }
    return result;
});

function hasValue(field: OperatorApplicationApi.AbstractFormElementOpenApiModel): boolean {
    let value = props.fieldValues[field.name];
    if ((typeof value == "string" || Array.isArray(value)) && !value.length) {
        return false;
    }
    return value != null;
}

let fieldNamesWithValuesAtMount = ref<string[]>([]);

function rebuildFieldNamesWithValuesAtMount(disallowAddNew: boolean) {
    let newValue = props.fields
        .filter(field => hasValue(field))
        .map(field => field.name);
    if (disallowAddNew) {
        newValue = newValue.filter(fieldName => fieldNamesWithValuesAtMount.value.includes(fieldName));
    }
    fieldNamesWithValuesAtMount.value = newValue
}

watch(computed(() => props.userdata.username), () => {
    rebuildFieldNamesWithValuesAtMount(false);
}, {
    immediate: true
})


let alwaysVisibleFieldNames = computed(() => {
    return props.fields
        .filter(field =>
            field.isAlwaysVisibleInApplication
            ||
            (
                field.isVisibleInApplication
                &&
                fieldNamesWithValuesAtMount.value.includes(field.name)
            )
        )
        .map(field => field.name);
});


let fieldsOfSite = computed(() => {
    let result = props.fields;
    for (let field of result) {
        if (field.type == FIELD_TYPE_TEXT) {
            (field.type as any) = FIELD_TYPE_TEXTAREA;
        }
        (field as OperatorApplicationApi.FormElementTextOpenApiModel).placeholder = field.descr;
    }
    return result;
});

let visibleFields = computed<OperatorApplicationApi.AbstractFormElementOpenApiModel[]>(() => {
    let result: OperatorApplicationApi.AbstractFormElementOpenApiModel[] = [];
    let wasNameField = false;

    if (!OperatorApplicationConfigInstance.hideNotFilledClientFieldsEnabled) {
        return fieldsOfSite.value;
    }
    let fields = ObjectHelper.dictionaryFromArray(fieldsOfSite.value, "name");
    for (let name of computedVisibleFieldNames.value) {
        let field = fields[name];

        if (field.type == FIELD_TYPE_TEXT) {
            (field.type as any) = FIELD_TYPE_TEXTAREA;
        }

        if (field) {
            let placeholder = field.descr;
            if (props.isClient) {
                if (NAME_FIELDS.includes(name)) {
                    if (!showSeparatedNameFields.value) {
                        if (!wasNameField) {
                            wasNameField = true;
                            placeholder = props.userdata.fields.descr ?? props.userdata.displayDescr;
                        } else {
                            continue;
                        }
                    }
                }
            }
            (field as OperatorApplicationApi.FormElementTextOpenApiModel).placeholder = placeholder;
            result.push(field);
        }
    }

    if (props.isCustom) {
        for (let key in props.fieldValues) {
            if (props.fieldValues.hasOwnProperty(key)) {
                if (!fields[key]) {
                    if (props.standartFieldNames?.includes(key)) {
                        continue;
                    }
                    let newField: OperatorApplicationApi.FormElementTextOpenApiModel = {
                        name: key,
                        descr: key,
                        icon: "ellipsis-h",
                        type: FIELD_TYPE_TEXTAREA as any,
                        placeholder: "",
                        suggest: [],
                        isAlwaysVisibleInApplication: false,
                        isVisibleInApplication: true,
                        isHiddenDefaultField: false
                    };
                    result.push(newField);
                }
            }
        }
    }

    return result;
});

let visibleFieldsForTemplateCycle = computed<OperatorApplicationApi.AbstractFormElementOpenApiModel[]>(() => {
    let fields: OperatorApplicationApi.AbstractFormElementOpenApiModel[] = visibleFields.value.length ? visibleFields.value : [{name: null} as any];
    return fields.filter(field => field.isVisibleInApplication && !field.isHiddenDefaultField);
});

let invisibleFields = computed<OperatorApplicationApi.AbstractFormElementOpenApiModel[]>(() => {
    return fieldsOfSite.value.filter(field => computedVisibleFieldNames.value.indexOf(field.name) == -1 && (field.isVisibleInApplication));
});

function isSavingNow(field: OperatorApplicationApi.AbstractFormElementOpenApiModel) {
    return savingNow.value.indexOf(field.name) > -1;
}

async function onFieldInputChange(name: string, value: any) {
    if (!isJoinedNameField(name)) {
        if (value === undefined) {
            return clearFieldValue(name);
        }
        fieldsModel.value[name] = value;
        try {
            await Delay.make(3000, `userdataFieldChange_${props.userdata.username}_${instanceId}`, true);
            saveFieldValues();
        } catch (e) {

        }
    }
}

function getFieldValuesHash() {
    return md5(JSON.stringify(props.fieldValues));
}

async function saveFieldValues() {
    let fields = ObjectHelper.jsonClone(fieldsModel.value);
    for (let fieldName in fields) {
        if (fields.hasOwnProperty(fieldName)) {
            toggleArrayElement(savingNow.value, fieldName, true);
        }
    }

    try {
        let hash = getFieldValuesHash();
        let result = await props.sendUpdateRequest(fields);
        if (!result.showMessageOnError()) {
            for (let i = 0; i < 10; i++) {
                if (hash === getFieldValuesHash()) {
                    await Delay.make(100);
                    continue;
                }
                for (let key in fields) {
                    if (fields.hasOwnProperty(key)) {
                        delete fieldsModel.value[key];
                    }
                }
                break;
            }
        }
    } catch (e) {

    }
    for (let fieldName in fields) {
        if (fields.hasOwnProperty(fieldName)) {
            toggleArrayElement(savingNow.value, fieldName, false);
        }
    }
    rebuildFieldNamesWithValuesAtMount(true);
}

function clearFieldValue(name: string) {
    props.fieldValues[name] = null;
    toggleArrayElement(visibleFieldNames.value, name, false);
    fieldsModel.value[name] = null;
    saveFieldValues();
}

function getRefByName(name: string): string {
    return `field_${name}`;
}

function addField(name: string) {
    toggleArrayElement(visibleFieldNames.value, name, true);
    nextTick(() => {
        let ref = instance.$refs[getRefByName(name)]
        if (Array.isArray(ref) && ref.length > 0) {
            (ref[0] as any as FormElementExposeInterface).focus();
        }
    });
}


let canEdit = computed(() => {
    return !props.readonly;
});


let showAddCustomFieldButton = computed(() => {
    return canEdit.value && invisibleFields.value.length;
});

let fieldWeights = computed(() => {
    let result: Dictionary<number> = {};
    let i = 0;
    for (let field of props.fields) {
        i++;
        result[field.name] = i;
    }
    return result;
})

let fio = computed(() => {
    let result: string[] = [];
    let fields = [...NAME_FIELDS].sort((a, b) => {
        return fieldWeights.value[a] < fieldWeights.value[b] ? -1 : 1;
    });

    for (let key of fields) {
        let value = props.userdata.fields[key];
        if (typeof value == "string" && value.length > 0) {
            result.push(value);
        }
    }
    return result.join(" ");
});

function getTextareaByInputName(name: string): HTMLTextAreaElement | null {
    let ref = instance.$refs[getRefByName(name)];
    if (Array.isArray(ref) && ref.length > 0) {
        let el: HTMLElement = (ref as any)[0].$el;
        if (el) {
            return el.querySelector("textarea");
        }
    }
    return null;
}

function onFieldMouseup(event: MouseEvent, name: string) {
    if (event.button == 0) {
        if (isJoinedNameField(name)) {
            setTimeout(async () => {
                try {
                    await Delay.make(200, `coreUiFieldMouseUp_${instanceId}`, true);
                    try {
                        let ref = instance.$refs[getRefByName(name)];
                        let input: HTMLTextAreaElement;
                        if (Array.isArray(ref) && ref.length > 0) {
                            input = (ref[0] as any).$el.querySelector("textarea:focus");
                        }
                        let selectionStart = input?.selectionStart ?? 0;
                        let selectionEnd = input?.selectionEnd ?? 0;
                        if (selectionStart != selectionEnd) {
                            return;
                        }
                        let currentFio = fio.value;
                        showSeparatedNameFields.value = true;

                        nextTick(() => {
                            setTimeout(() => {
                                if (currentFio.length == 0) {
                                    let input = getTextareaByInputName(CLIENT_FIELD_FIRST_NAME);
                                    if (input) {
                                        input.focus();
                                        return;
                                    }
                                }
                                if (currentFio.length >= selectionEnd) {
                                    for (let partName of NAME_FIELDS) {
                                        let value = props.userdata.fields[partName];
                                        if (typeof value == "string" && value.length > 0) {
                                            if (selectionStart <= value.length) {
                                                let input = getTextareaByInputName(partName);
                                                if (input) {
                                                    input.setSelectionRange(selectionStart, selectionEnd);
                                                    input.focus();
                                                }
                                                break;
                                            }
                                            selectionStart -= value.length + 1;
                                            selectionEnd -= value.length + 1;
                                        }
                                    }
                                }
                            }, 1);
                        })
                    } catch (e) {
                        console.error(e);
                    }
                } catch (e) {
                }
            }, 1);

        }
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleFieldsForTemplateCycle), (field, fieldKey) => {
      return _withDirectives((_openBlock(), _createBlock(ClientField, {
        key: field.name,
        userdata: __props.userdata,
        links: __props.links,
        "field-values": __props.fieldValues,
        field: field,
        "next-field": _unref(visibleFieldsForTemplateCycle)[fieldKey + 1],
        "is-saving-now": isSavingNow(field),
        "model-value": isJoinedNameField(field.name) ? _unref(fio) : (_unref(fieldsModel).hasOwnProperty(field.name) ? _unref(fieldsModel)[field.name] : undefined),
        "joined-fields": isJoinedNameField(field.name) ? _unref(NAME_FIELDS) : undefined,
        ref_for: true,
        ref: getRefByName(field.name),
        "show-icon": __props.showIcons,
        "show-title": __props.showTitles,
        "can-edit": _unref(canEdit),
        onRemove: ($event: any) => (clearFieldValue(field.name)),
        "onUpdate:modelValue": ($event: any) => (onFieldInputChange(field.name, $event))
      }, null, 8, ["userdata", "links", "field-values", "field", "next-field", "is-saving-now", "model-value", "joined-fields", "show-icon", "show-title", "can-edit", "onRemove", "onUpdate:modelValue"])), [
        [_directive_on_native, (event) => onFieldMouseup(event, field.name), "mouseup"]
      ])
    }), 128)),
    (__props.isCustom)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(showAddCustomFieldButton))
            ? (_openBlock(), _createBlock(SideMenuCardSection, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown, {
                    class: "d-block",
                    trigger: "click",
                    onCommand: _cache[0] || (_cache[0] = ($event: any) => (addField($event)))
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_el_dropdown_menu, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invisibleFields), (field) => {
                            return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                              key: field.name,
                              command: field.name
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(field.descr), 1)
                              ]),
                              _: 2
                            }, 1032, ["command"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        plain: "",
                        class: "d-block w-100"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(__)("Добавить новое поле")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})